<template>
    <!-- TODO: Implement "sizes" prop with desktopSrc & mobileSrc -->
    <!-- TODO: Implement "srcset" prop with desktopSrc & mobileSrc -->
    <v-img
        v-bind="$attrs"
        class="base-image"
        :src="imageSrc"
    >
        <slot/>

        <template v-slot:placeholder>
            <v-row
                align="center"
                :class="[
                    'base-image__placeholder',
                    'fill-height',
                    placeholderColorBackground,
                ]"
                justify="center"
            >
                <slot name="placeholder">
                    <v-progress-circular
                        class="base-image__spinner"
                        :color="placeholderColorForeground"
                        indeterminate
                    />
                </slot>
            </v-row>
        </template>
    </v-img>
</template>

<script>
export default {
    name: "BaseImage",

    props: {
      desktopSrc: {
          type: String,
      },

      mobileSrc: {
          type: String,
      },

      placeholderColorBackground: {
          type: String,
          default: "grey darken-4",
      },

      placeholderColorForeground: {
          type: String,
          default: "grey darken-2",
      },

      src: {
          type: String,
      },
    },
    computed: {
        imageSrc() {
            if (this.src) {
                return this.src;
            }

            if (this.$vuetify.breakpoint.smAndUp || !this.mobileSrc) {
                return this.desktopSrc;
            }

            return this.mobileSrc;
        },
    },
}
</script>